import React from 'react';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  label: {
    textTransform: 'uppercase',
    fontSize: '12px',
    fontWeight: 'bold',
    letterSpacing: 1,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontFamily: 'Gilroy',
  },
});

export const ContentSection = ({
  label,
  gridSizes,
  children,
}: {
  label: string;
  children: React.ReactNode;
  gridSizes?: Record<string, number>;
}) => {
  const classes = useStyles();
  return (
    <Grid item {...gridSizes}>
      <Box flex={1}>
        <Typography variant="h2" className={classes.label}>
          {label}
        </Typography>
      </Box>
      {children}
    </Grid>
  );
};
